<div class="page">
  <app-page-header itemName="{{ ddt.get('name') }}" page-title="ddts.detail.pageTitle"></app-page-header>
  <div class="page-content">
    <mat-card class="custom-card" id="content-to-print">
      <mat-card-title>{{ 'ddts.detail.editTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>

          <app-creator-updator-box [data]="ddt"></app-creator-updator-box>
          <div class="row mt-3">
            <!-- QR-CODE -->
            <div class="col-6 p-3" *ngIf="qrcodeData !== ''">
              <qrcode [qrdata]="qrcodeData" [width]="150" [errorCorrectionLevel]="'H'"></qrcode>
            </div>
            <div class="col-6 p-3 text-right">
              <mat-spinner-button (btnClick)="onPrintDetails()" [options]="printDetailsBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <mat-chip-list class="d-block py-2">
                <div *ngIf="ddt.get('status') === 'open'">
                  <mat-chip selected class="chip-green" matTooltip="{{ 'ddts.status.tooltip' | translate }}">
                    {{ 'ddts.status.open' | translate }}
                  </mat-chip>
                  <button mat-stroked-button matTooltip="{{ 'ddts.status.moveToClosedTooltip' | translate }}"
                    (click)="onStatusChange()">
                    {{ 'ddts.status.moveToClosed' | translate }}
                  </button>
                </div>
                <div *ngIf="ddt.get('status') === 'closed'">
                  <mat-chip selected class="chip-red" matTooltip="{{ 'ddts.status.tooltip' | translate }}">
                    {{ 'ddts.status.closed' | translate }}
                  </mat-chip>
                </div>
              </mat-chip-list>
            </div>
            <div class="col-12 col-sm-6 col-md-8 col-lg-9 align-self-center">
              <strong>{{ 'ddts.fields.code' | translate }}:</strong> {{ ddt.get('code') }}
            </div>
            <!-- TABLE -->
            <div class="col-12 col-lg-6 mt-4">
              <table class="table ddt-detail-table">
                <thead>
                  <th>{{ 'ddts.fields.ddt' | translate }}</th>
                  <th>{{ 'ddts.fields.docsQty' | translate }}</th>
                  <th>{{ 'ddts.fields.filesQty' | translate }}</th>
                </thead>
                <tbody>
                  <!-- ROW 1 -->
                  <tr>
                    <th class="heading-column">
                      {{ 'ddts.fields.singleDocs' | translate }}
                    </th>
                    <td>{{ singleDocsQty }}</td>
                    <td>{{ singleFilesQty }}</td>
                  </tr>
                  <!-- ROW 2 -->
                  <tr>
                    <th class="heading-column">
                      {{ 'ddts.fields.multiDocs' | translate }}
                    </th>
                    <td>{{ multiDocsQty }}</td>
                    <td>{{ multiFilesQty }}</td>
                  </tr>
                  <!-- ROW 3 -->
                  <tr>
                    <th class="heading-column">
                      {{ 'ddts.fields.total' | translate }}
                    </th>
                    <td>{{ singleDocsQty + multiDocsQty }}</td>
                    <td>{{ singleFilesQty + multiFilesQty }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- FILES TABLE -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>{{ 'ddts.detail.filesTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'ddts.detail.filesTab.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12 mt-4">
              <table class="table table-borderless table-striped custom-table-data" matSort
                (matSortChange)="sortData($event)">
                <thead>
                  <th>
                    {{ 'ddts.detail.filesTab.fields.numPosition' | translate }}
                  </th>
                  <th class="clickable" mat-sort-header="code">
                    {{ 'ddts.detail.filesTab.fields.code' | translate }}
                  </th>
                  <th class="clickable" mat-sort-header="numFiles">
                    {{ 'ddts.detail.filesTab.fields.numFiles' | translate }}
                  </th>
                  <th class="clickable" mat-sort-header="master">
                    {{ 'ddts.detail.filesTab.fields.master' | translate }}
                  </th>
                  <th class="clickable" mat-sort-header="property">
                    {{ 'ddts.detail.filesTab.fields.property' | translate }}
                  </th>
                  <th class="clickable" mat-sort-header="status">
                    {{ 'ddts.detail.filesTab.fields.status' | translate }}
                  </th>
                  <th>{{ 'common.cta.actions' | translate }}</th>
                </thead>
                <tbody>
                  <!-- ROW 1 -->
                  <tr *ngFor="let item of sortedData; let i = index;">
                    <td><strong>{{ i + 1 }}</strong></td>
                    <td>{{ item.code }}</td>
                    <td>
                      {{ item.numFiles }}
                    </td>
                    <td>{{ item.property.admin.company.name }}</td>
                    <td>{{ item.property.name }}</td>
                    <td>
                      {{ 'ddts.detail.filesTab.fields.' + getStatus(item.files) | translate }}
                    </td>
                    <td>
                      <mat-spinner-button (btnClick)="onPrint('module', item)" [options]="printModuleBtnOptions"
                        class="btn-elevate">
                      </mat-spinner-button>
                      <mat-spinner-button (btnClick)="onPrint('qr', item)" [options]="printQrBtnOptions"
                        class="btn-elevate ml-3">
                      </mat-spinner-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->